// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".qrcode[data-v-d0073efc]{margin-left:auto;margin-right:auto;width:66.666667%;cursor:copy}.copy_text[data-v-d0073efc]{text-align:center;font-size:.875rem;line-height:1.25rem}", ""]);
// Exports
module.exports = exports;
